import { Dialog, Toolbar } from "client/Components";
import { ReactElement } from "react";
import { localize } from "client_legacy/ndaw/culture";

export type CancelEmailComposeDialogProps = {
	onKeep(): void;
	onRemove(): void;
	onCancel(): void;
};

export const CancelEmailComposeDialog = (props: CancelEmailComposeDialogProps): ReactElement => {
	const {
		onKeep,
		onRemove,
		onCancel
	} = props;

	return (
		<Dialog
			trackingId="cancel-email-compose-dialog"
		>
			<Dialog.Header
				title={localize("_StoreInDraftFolder")}
				onClose={onCancel}
			/>
			<Dialog.Body>
				<p>{localize("_BodyOfCancelNewEmail")}</p>
			</Dialog.Body>
			<Dialog.Footer>
				<Toolbar>
					<Toolbar.Button
						trackingId="keep"
						text={localize("_Keep")}
						kind="primary"
						onClick={onKeep}
					/>
					<Toolbar.Button
						trackingId="remove"
						text={localize("_Remove")}
						kind="primary"
						onClick={onRemove}
					/>
					<Toolbar.Button
						trackingId="cancel"
						text={localize("_Cancel")}
						kind="secondary"
						onClick={onCancel}
					/>
				</Toolbar>
			</Dialog.Footer>
		</Dialog>
	);
};
CancelEmailComposeDialog.displayName = "CancelEmailComposeDialog";